import React, {
  Component,
  useContext,
  useState,
  useEffect,
  useRef,
  Fragment,
} from "react";
import styled, { css } from "styled-components";

import Tap from "react-interactions";


export const getBoundingClientRect = element => {
  const rect = element.getBoundingClientRect();
  return {
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    width: rect.width,
    height: rect.height,
    x: rect.x,
    y: rect.y
  };
};



export const CssLoginPop0 = styled.div`
  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
  }

  @media (max-width: 479px) {
  }
`;

const debug = true;

export function SbSelect({
  options = [],
  active,
  menuHandler = () => {
    void 0;
  },
  handleReset,
  placeholder = "Select",
  extra,
  help,
  onHover = true,
  width,
  theme = "sb",
}) {
  useEffect(() => {
    //  console.log('active = ', active);
  }, [active]);

  const drop = useRef(null);
  const [pos, setPos] = useState(null);

  const [height, setHeight] = useState(null);

  useEffect(() => {
    let windowHeight = window.innerHeight;
    if (pos && drop.current) {
      let dropPos = getBoundingClientRect(drop.current);
      setHeight(windowHeight/ 2 - 200)
      if (windowHeight < pos.bottom + dropPos.height) {
        setToTop(true);
      } else {
        setToTop(false);
      }
    }
  }, [pos]);

  const [toTop, setToTop] = useState(false);

  const [shown, setShown] = useState(false);

  return (
    <div className="xx_set_line" style={{ display: "block" }}>
      <div className="x_flex x_flex--vcenter">
        <CssSelect
          className="xsb_but_link_input"
          shown={shown}
          onClick={(e) => {
            if (!shown) {
              setShown(true);
              setPos(getBoundingClientRect(e.target));
            }
          }}
        >
          {shown && <CssZ theme={theme} width={320} />}

          <div
            ref={drop}
            className={`${
              toTop
                ? "xsb_select_drop0 xsb_select_drop0--top"
                : "xsb_select_drop0"
            }`}
            // shown={shown}
            onMouseLeave={() => {
              !debug && setShown(false);
            }}
          >
            <CssSelectPlaceholder
              toTop={toTop}
              shown={shown}
              onClick={() => {
                if (shown) setShown(false);
              }}
            >
              {placeholder && typeof active === "undefined" && (
                <div className="xsb_but_seturl_placeholder">{placeholder}</div>
              )}

              {typeof active !== "undefined" && (
                <div className="xsb_but_seturl_placeholder">
                  {options.map((item) => {
                    let ret =
                      active === item["value"]
                        ? typeof item["title"] === "string"
                          ? item["title"]
                          : item["title"]()
                        : "";
                    return ret ? ret : null;
                  })}
                </div>
              )}

              <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                <div>expand_more</div>
              </div>
            </CssSelectPlaceholder>

            <CssSelectB
              shown={shown}
              className="xsb_select_drop"
              style={{
                boxShadow: "0 3px 22px 4px rgba(64, 69, 74, 0.31)",
              }}
              // theme={valueFromContext.getTheme()}
            >
              {/* <CssMenuLi
                  className="xsb_select_drop_li"
                  key={`preset_0`}
                  onClick={(e)=>{
                    e.preventDefault();
                    setShown(false);
                  }}
                >
              </CssMenuLi> */}

              {typeof extra !== "undefined" && (
                <CssMenuLi
                  className="xsb_select_drop_li"
                  key={`preset_custom`}
                  onMouseEnter={(e) => {
                    e.preventDefault();
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  {extra}
                </CssMenuLi>
              )}

              {options.map((item, ind) => (
                <CssMenuLi
                  active={active === item["value"]}
                  className="xsb_select_drop_li"
                  key={`preset_${item["value"] ? item["value"] : item["defaultValue"]}`}
                  onMouseEnter={(e) => {
                    e.preventDefault();
                    shown && onHover && menuHandler(item["value"]);
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    menuHandler(item["value"]);
                    setShown(false);
                  }}
                >
                  {typeof item["title"] === "string"
                    ? item["title"]
                    : item["title"]()}
                </CssMenuLi>
              ))}

              {!!handleReset && (
                <CssMenuLi
                  className="xsb_select_drop_li"
                  key={`preset_reset`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleReset();
                    setShown(false);
                  }}
                >
                  <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                    backspace
                  </div>{" "}
                  Reset
                </CssMenuLi>
              )}

              {help}
            </CssSelectB>
          </div>
        </CssSelect>
      </div>
    </div>
  );
}

export function SbCatSelect({
  options = [],
  help,
  activeModule = "virtualItems",
  activeGroup = 9999,
  activeSubGroup,
  menuHandler = () => {
    void 0;
  },
  onHover = false,
  theme='sb',
}) {
  const drop = useRef(null);
  const [pos, setPos] = useState(null);

  useEffect(() => {
    let windowHeight = window.innerHeight;
    if (pos && drop.current) {
      let dropPos = getBoundingClientRect(drop.current);
      if (windowHeight < pos.bottom + dropPos.height) {
        setToTop(true);
      } else {
        setToTop(false);
      }
    }
  }, [pos]);

  const [shown, setShown] = React.useState();

  const [toTop, setToTop] = useState(false);

  if (activeGroup === 'first') activeGroup = options[0]["items"][0]["id"]

  return (
    <div className="xx_set_line" style={{ display: "block" }}>
      <div className="x_flex x_flex--vcenter">
        <CssSelect
          className="xsb_but_link_input"
          shown={shown}
          onClick={(e) => {
            setShown(!shown);
            setPos(getBoundingClientRect(e.target));
          }}
        >
          {shown && <CssZ theme={theme} width={320} />}

          <div
            ref={drop}
            className={`${
              toTop
                ? "xsb_select_drop0 xsb_select_drop0--top"
                : "xsb_select_drop0"
            }`}
            // shown={shown}
            onMouseLeave={() => {
              !debug && setShown(false);
            }}
          >
            <CssSelectPlaceholder toTop={toTop} shown={shown}>
              <div
                className="xsb_but_seturl_placeholder"
                // style={{position: 'absolute', zIndex: 1000000}}
              >
                {/* {active} */}
                {activeModule === "virtualItems" &&
                  options[0]["items"].map((oneGroup) => {
                    let ret = activeGroup === oneGroup["id"] ? oneGroup["name"] : "";

                    if (activeSubGroup && oneGroup.children.length) {
                      debugger
                      let subName = oneGroup.children.filter(oneG=>oneG['id'] === activeSubGroup)[0]
                      ret = subName ? ret += ' / ' + subName['name'] : ret;
                    }

                    return ret ? ret : null;
                  })}

                {activeModule === "currency" && (
                  <div className="">Virtual currency</div>
                )}

                {activeModule === "subscriptions" && (
                  <div className="">Subscriptions</div>
                )}
              </div>
              <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                <div>expand_more</div>
              </div>
            </CssSelectPlaceholder>

            <CssSelectB
              shown={shown}
              className="xsb_select_drop"
              // theme={valueFromContext.getTheme()}
            >
              {options.map((oneModule, ind) => {
                return (
                  <CssSelectUl key={`ul_${ind}`} style={{overflow:'auto', maxHeight: window.innerHeight / 2 - 200}}>
                    {oneModule["title"] && (
                      <CssMenuLi
                        active={activeModule === oneModule["module"]}
                        className="xsb_select_drop_li"
                        onClick={(e) => {
                          e.preventDefault();
                          oneModule.menuHandler();
                          setShown(false);
                        }}
                      >
                        {oneModule["title"]}
                      </CssMenuLi>
                    )}

                    {oneModule["items"] &&
                      oneModule["items"].map((oneGroup, ind) => {
                        //  console.log('oneGroup = ', oneGroup);
                        return (<Fragment>
                          <CssMenuLi
                            active={
                              activeModule === "virtualItems" &&
                              activeGroup === oneGroup["id"]
                            }
                            className="xsb_select_drop_li"
                            key={oneGroup["id"]}
                            onMouseEnter={(e) => {
                              e.preventDefault();
                              shown && onHover && menuHandler(oneGroup["id"]);
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              oneModule.menuHandler(oneGroup["id"]);
                              setShown(false);
                            }}
                          >
                            ⊢ {oneGroup["name"]}
                          </CssMenuLi>

                          {!!oneGroup['children'].length &&
                            oneGroup['children'].map((oneSubGroup, ind) => {
                              return (
                                <CssMenuLi
                                  key={`sub_${oneSubGroup["id"]}_${ind}`}
                                  active={
                                    activeModule === "virtualItems" &&
                                    activeGroup === oneSubGroup["id"]
                                  }
                                  className="xsb_select_drop_li"
                                  key={oneSubGroup["id"]}
                                  onMouseEnter={(e) => {
                                    e.preventDefault();
                                    shown && onHover && menuHandler([oneGroup["id"], oneSubGroup["id"]]);
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    oneModule.menuHandler([oneGroup["id"], oneSubGroup["id"]]);
                                    setShown(false);
                                  }}
                                >
                                  ⊢— {oneSubGroup["name"]}
                                </CssMenuLi>
                        )
                      })}


                          </Fragment>
                        );
                      }
                      )}

                    {help}
                  </CssSelectUl>
                );
              })}
            </CssSelectB>
          </div>
        </CssSelect>
      </div>
    </div>
  );
}

export const CssSelectUl = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;

export const CssSelectB = styled.div`
  transition: all 150ms ease-in-out;
  transform: translateY(-8px);
  padding: 0;
  opacity: 0;
  /* z-index: 0; */
  ${({ shown }) =>
    shown &&
    css`
       {
        transform: translateY(0px);
        opacity: 1;
        /* z-index: 1; */
      }
    `};

  /* &:not(:hover) div {
    background-color: inherit;
    color: blue;
  } */
`;

export const CssSelectPlaceholder = styled.div`
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0px;
  bottom: auto;
  z-index: 10000;
  min-height: 44px;
  padding-top: 0px;
  display: flex;
  align-items: center;
  border-radius: 3px;

  ${({ toTop }) =>
    toTop &&
    css`
       {
        bottom: 0px;
        top: auto;
      }
    `};

  ${({ shown }) =>
    shown &&
    css`
       {
        background-color: #fff;
        box-shadow: inset 0 0 0 2px #157afb;
        color: #00244d;
      }
    `};

  /* &:not(:hover) div {
    background-color: inherit;
    color: blue;
  } */

  .xx_set_sect & {
    opacity: 0.8;
  }
  .xx_set_sect:hover & {
    opacity: 1;
  }
`;

export const CssSelect = styled.div`
  overflow: ${({ shown }) => (shown ? "visible" : "hidden")};
  z-index: 0;
  ${({ shown }) =>
    shown &&
    css`
       {
        z-index: 1;
      }
    `};
`;
export const CssMenuLi = styled.div`
  color: ${({ active }) => (active ? "#157afb" : "inherit")};
  font-weight: ${({ active }) => (active ? "bolder" : "normal")};

  /* background-color: ${({ active }) =>
    active ? "#157afb" : "transparent"}; */
`;

const CssZ = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: ${({ width }) => (width ? `${width}px` : "100%")};
  z-index: -1;
  background: ${({ theme }) => (theme === 'sb' ? 'rgba(0, 0, 0, 0.56)' : 'rgba(197, 208, 219, 0.56)')};
`;
